import React from 'react'

interface TrIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const TrIcon = (props: TrIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_94721)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1.19922H21V21.1992H1V1.19922Z"
          fill="#E30A17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6094 9.17578L15.5703 11.0234L13.8438 11.4922L15.543 12.0977L15.5039 13.7891L16.6094 12.4688L18.2852 13.0469L17.3164 11.6289L18.4961 10.2188L16.6836 10.7188L15.6094 9.17578Z"
          fill="white"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_94721">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
